export default __webpack_public_path__ + "static/media/lobby-speaker-stand.4e852b0f.png";